document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      document.querySelectorAll('.footer-accordion-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          const accordion = this.parentElement;
          const content = this.nextElementSibling;
          const isOpen = accordion.classList.contains('open');

          if (isOpen) {
            accordion.classList.remove('open');
            content.style.maxHeight = null;
            // this.querySelector('.footer-accordion-icon').textContent = '+';
          } else {
            // document.querySelectorAll('.footer-accordion-content.open').forEach(function (c) {
            //   c.classList.remove('open');
            //   c.style.maxHeight = null;
            //   c.previousElementSibling.querySelector('.footer-accordion-icon').textContent = '+';
            // });

            accordion.classList.add('open');
            content.style.maxHeight = content.scrollHeight + "px";
            // this.querySelector('.footer-accordion-icon').textContent = '−';
          }
        });
      });
    }
});